import React from 'react';

interface CreatePostContentProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const CreatePostContent: React.FC<CreatePostContentProps> = ({ value, onChange }) => {
  return (
    <div className="w-full px-4 py-2">
      <textarea
        className="w-full min-h-[100px] p-2 text-[#1E3A3A] text-base font-normal font-sora leading-tight bg-transparent resize-none focus:outline-none"
        placeholder="Bạn đang nghĩ gì?"
        rows={4}
        value={value}
        onChange={onChange}
      />
    </div>
  );
}; 